import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Route, Routes, useLocation } from 'react-router-dom';
import NavigationButtons from './NavigationButtons';
import PhoneHeader from './PhoneHeader';
import Home from './Home';
import Register from './Register';
import RegisterPattern from './RegisterPattern';
import Challenge from './Challenge';
import Settings from './Settings';
import Reset from './Reset';
import StartPage from './StartPage';
// import BlankPhone from './BlankPhone';
import Privacy from './Privacy';
import Agree from './Agree';
import HomeButtons from './HomeButtons';
import Profile from './Profile';
import Help from './Help';
import About from './About';
import LoginFailure from './challenge/LoginFailure';
import LoginSuccess from './challenge/LoginSuccess';
import PrivacyStatement from './PrivacyStatement';

export default function PhoneContainer() {
  const theme = useTheme();
  const location = useLocation();

  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: '20px',
        width: '80vw',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >

      {/* <Typography variant='h5'>
        Phone Container component
      </Typography> */}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '20px',
          padding: '10px',
          fontSize: '1.5em',
          color: 'black',
          marginRight: 'auto',
          marginLeft: 'auto',
          border: '10px solid black',
          borderRadius: '20px',
          height: '853px',
          width: '393px',
          justifyContent: 'space-between',
          // backgroundColor: '#f5fffaab',
          backgroundColor: location.pathname == '/' ||
            location.pathname == '/agree' ||
            location.pathname == '/settings' ||
            location.pathname == '/profile' ||
            location.pathname == '/home' ||
            location.pathname == '/about' ||
            location.pathname == '/privacy-statement' ||
            location.pathname == '/help' ||
            location.pathname == '/register' ?
            '#000000' :
            location.pathname == '/' ?
              '#f5fffaab' :
              location.pathname == '/success' ?
                'rgb(23 163 74)' :
                location.pathname == '/failure' ?
                  '#F44334' :
                  '#FFFFFF',
        }}
      >


        {/* background-color: rgb(17, 24, 39); */}

        <PhoneHeader />

        {/* 
ADD Settings
Make Home page a Profile page
Add reset pattern page */}
        <Box
          sx=
          {{
            // backgroundColor: 'green',
            height: '100%',
          }}
        >
          <Routes>
            {/* <Route path='/' element={<StartPage />}></Route> */}
            <Route path='/' element={<Privacy />}></Route>
            <Route path='/home' element={<Home />}></Route>
            <Route path='/profile' element={<Profile />}></Route>
            <Route path='/register' element={<Register />}></Route>
            {/* <Route path='/privacy' element={<Privacy />}></Route> */}
            <Route path='/register-pattern' element={<RegisterPattern />}></Route>
            <Route path='/challenge' element={<Challenge />}></Route>
            <Route path='/settings' element={<Settings />}></Route>
            <Route path='/agree' element={<Agree />}></Route>
            <Route path='/help' element={<Help />}></Route>
            <Route path='/about' element={<About />}></Route>
            <Route path='/failure' element={<LoginFailure />}></Route>
            <Route path='/success' element={<LoginSuccess />}></Route>
            <Route path='/privacy-statement' element={<PrivacyStatement />}></Route>
          </Routes>
        </Box>
        {/* {location.pathname == '/' ?
          <BlankPhone /> :
          null
        } */}

        {location.pathname == '/'
          // ? <HomeButtons /> :
          // location.pathname == '/privacy'
          // || location.pathname == '/agree'
          || location.pathname == '/agree'
          || location.pathname == '/register'
          || location.pathname == '/success'
          || location.pathname == '/failure' ?
          null :
          <NavigationButtons />
        }

        {/* {location.pathname == '/'
          || location.pathname == '/privacy'
          || location.pathname == '/agree'
          || location.pathname == '/register' ?
          null :
          <NavigationButtons />
        } */}
      </Box>
    </Box>
  );
};